import { Controller } from "@hotwired/stimulus";

// Builder d'email no-code : ajoute/retire des blocs (titre, texte, bouton, image,
// séparateur) et rend un aperçu live. Chaque bloc soumet type/text/url dans
// l'ordre constant -> groupage en tableau côté Rails.
export default class extends Controller {
  static targets = ["blocks", "preview", "templates", "blockRow"];

  connect() {
    this.refresh();
  }

  addBlock(event) {
    const type = event.currentTarget.dataset.blockType;
    const tpl = this.templatesTarget.querySelector(`template[data-block-type='${type}']`);
    if (!tpl) return;
    this.blocksTarget.appendChild(tpl.content.firstElementChild.cloneNode(true));
    this.refresh();
  }

  removeBlock(event) {
    const row = event.currentTarget.closest("[data-marketing-email-builder-target='blockRow']");
    if (row) row.remove();
    this.refresh();
  }

  refresh() {
    if (!this.hasPreviewTarget) return;
    const html = this.blockRowTargets.map((row) => this.renderRow(row)).join("");
    this.previewTarget.innerHTML = html || "<p style='color:#94a3b8'>Ajoutez des blocs pour composer votre email.</p>";
  }

  renderRow(row) {
    const type = row.dataset.blockType;
    const text = row.querySelector("input[name*='[text]'],textarea[name*='[text]']")?.value || "";
    const url = row.querySelector("input[name*='[url]']")?.value || "";
    const esc = (s) => (s || "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
    switch (type) {
      case "heading":
        return `<h1 style="font-size:22px;color:#0f172a;margin:0 0 14px">${esc(text)}</h1>`;
      case "text":
        return `<p style="font-size:15px;color:#374151;line-height:1.6;margin:0 0 14px">${esc(text).replace(/\n/g, "<br>")}</p>`;
      case "button":
        return `<p style="margin:0 0 16px"><a style="background:#4f46e5;color:#fff;padding:11px 20px;border-radius:8px;text-decoration:none;display:inline-block">${esc(text) || "Bouton"}</a></p>`;
      case "image":
        return url ? `<p><img src="${esc(url)}" style="max-width:100%;border-radius:8px"></p>` : `<div style="background:#f1f5f9;border-radius:8px;padding:30px;text-align:center;color:#94a3b8;margin-bottom:14px">Image</div>`;
      case "divider":
        return `<hr style="border:none;border-top:1px solid #e5e7eb;margin:18px 0">`;
      default:
        return "";
    }
  }
}
